import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { AppService } from 'src/app/app.service';
import * as FileSaver from 'file-saver';
import { Modal } from 'src/app/common/modal/modal';
import { ModalService } from 'src/app/common/modal/modal.service';

@Component({
    selector: 'app-form-field-file-download',
    templateUrl: './form-field-file-download.component.html',
    styleUrls: ['./form-field-file-download.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldFileDownloadComponent implements OnInit {
  commonSubject: any;

  constructor(private appService: AppService, private modalService: ModalService,private cd: ChangeDetectorRef) { }

  @Input() configData;
  @Input() frmGroup;

  @Input() manualConfig;

  downloadUrl;
  color: String = 'primary';
  mode: String = 'indeterminate';
  isLoading: boolean = false;

  normalView(){
    document.getElementById("overlay").style.display = "none";
  }

  ngOnInit() {
    if (this.configData['editable'] === false) {
      this.frmGroup.get(this.configData.name).disable();
    }
    if (this.configData.downloadUrl) {
      if(this.configData.urlType){
        this.configData.urlType === 'full' ? this.downloadUrl = this.configData.downloadUrl : this.downloadUrl = this.configData.downloadUrl + localStorage.getItem('customerCode') +
        '&userId=' + localStorage.getItem('userName');
      } else{
        this.downloadUrl = this.configData.downloadUrl + localStorage.getItem('customerCode') +
        '&userId=' + localStorage.getItem('userName');
      }      
    }

    if(this.frmGroup?.value?.ctrlSubStatus == 'COMPLETED'){
      this.frmGroup.get(this.configData?.name).enable();
    }
  }

    ngAfterViewInit() {
    this.commonSubject = this.appService._commonComponentSubject.subscribe(res => {
      this.cd.detectChanges()
    })
  }

  downloadFile() {
    document.getElementById("overlay").style.display = "block";
    const formName = this.configData?.formName;

    //Cp-3513 - start - export order to csv
    if (this.configData.exportToCSV && this.configData.formName) {
      const component = this.appService._components[formName];
      const tableRows = component.tableRows;
      const tableRowsClone = component?.tableRowsClone;
      const isMassPORelease = component?.isMassPORelease;

      let data = isMassPORelease ? tableRowsClone : tableRows;
      let limit = this.configData.ordersLimit || 1000;
      try {
        if (data && data.length > limit) {
          throw new Error(this.configData.limitExceedMessage);
        }
        else if((data && data.length < 1) || !data){
          throw new Error(this.configData.noOrderErrorMessage);
        }
        let replacer = (key, value) => (value !== null && value !== undefined) ? value.toString().replaceAll(",", ";") : ''; //  0 should not be considered null/undefined
         let csvDynamicHeaders=this.configData?.csvHeaders;
        let header: string[];
        if(csvDynamicHeaders)
        // let header: string[] = this.configData.columnName || Object.keys(data[0]);
         header= csvDynamicHeaders.map(fielname=>fielname.title) || Object.keys(data[0]);
         else
         header= this.configData.columnName || Object.keys(data[0]);
        let csv = data.map(row => header.map(fieldName => {
          let text: string  = JSON.parse(JSON.stringify(row[fieldName], replacer)).trim();
          const transformer: string = this.configData?.transformer && this.configData?.transformer[fieldName];
          if (transformer) {
            if (transformer === "REMOVE_TIMESTAMP") {
              text = text.substring(0, text.lastIndexOf('|'));
              return text;
            }

            if (transformer.includes('JOIN-')) {
              const fieldsToJoin = transformer.substring(5).split(',');
              // text = fieldsToJoin.map((field) => row[field]).join(' | ')
              // to avoid displaying an empty separator ("|") in the exported CSV.
              text = fieldsToJoin.map(field => row[field]).filter(value => value !== null && value !== undefined && value !== '').join(' | ');
              return text;
            }
          }

          return text;
        }).join(','));

        // If custom column names
        header = this.configData?.mapNames || header;
        csv.unshift(header.join(','));
        let csvArray = csv.join('\r\n');

        let fileName = localStorage.getItem("customerName") || "COX";
        fileName += "_" + this.configData.screenName;
        fileName += "_" + localStorage.getItem("userName").split("@")[0];
        fileName += "_" + this.appService.getCurrentDateAndTime();

        let blob = new Blob([csvArray], { type: 'text/csv' })
        FileSaver.saveAs(blob, fileName + ".csv");

        setTimeout(() => {
          this.normalView();
          this.isLoading = false;
        }, 2000);
      }
      catch (e) {
        this.normalView();
        this.isLoading = false;
        let message = this.configData.genericErrorMessage;
        if ((data && data.length > limit) || (data && data.length < 1) || !data ) {
          message = e.message;
        }
        let modal = new Modal({
          action: false, name: 'download', title: 'Export Orders', description: message, actionButtonText: ''
        });
        this.modalService.createModalBox(modal, 400);
      }    
    }//cp-3513-end

    else{
      if(this.downloadUrl== undefined && this.downloadUrl !== undefined ){
        this.downloadUrl=this.appService._components[this.configData.name].configData.downloadUrl
        this.appService._components[this.configData.name].configData.disabled=false
      }else if(this.frmGroup?.get('transactionId')){
        this.frmGroup.get(this.configData.name).enable();
        this.downloadUrl = this.configData?.downloadUrl + localStorage.getItem('userName') + '&customerCode=' + localStorage.getItem('customerCode') + '&transactionId=' + this.frmGroup.get('transactionId').value + '&action=CREATE_ORDER' + '&fileType=resultant';
      }
          this.appService.makeHttpDocRequest(this.downloadUrl).subscribe((data: any) => {
        console.log(data);
        this.normalView();
        this.isLoading = false;
        // this.frmGroup['spinner'] = false;
  
        let fileName = "Master Data ";
        fileName += this.appService.getCurrentDateAndTime();
  
        fileName = this.configData.fileName || fileName;
      
        FileSaver.saveAs(data, fileName + ".xlsx");

      }, async (err) => {
  
        this.normalView();
        this.isLoading = false;
        // this.frmGroup['spinner'] = false;
        // this.loadSpinner.emit(false);
  
        const message = JSON.parse(await err.error.text()).message.statusMessage;
  
        let modal = new Modal({
          action: false, name: 'download', title: 'Download File', description: message, actionButtonText: ''
        });
        this.modalService.createModalBox(modal, err.status);
  
        console.log(err);
      })
    }
  }  
}